import React, { useState } from 'react';
import { mockLogs } from '../data/mockData';
import { Search, Filter, Calendar, Download } from 'lucide-react';
export const AuditTrail: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const filteredLogs = mockLogs.filter(log => log.user.toLowerCase().includes(searchTerm.toLowerCase()) || log.action.toLowerCase().includes(searchTerm.toLowerCase()) || log.item.toLowerCase().includes(searchTerm.toLowerCase()));
  return <div className="max-w-7xl mx-auto" data-id="element-311">
      <div className="flex justify-between items-end mb-6" data-id="element-312">
        <div data-id="element-313">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-314">অডিট ট্রেইল</h1>
          <p className="text-slate-500" data-id="element-315">
            কমপ্লায়েন্স এবং ট্র্যাকিংয়ের জন্য সিস্টেম-ব্যাপী অ্যাক্টিভিটি লগ
          </p>
        </div>
        <button className="btn-secondary flex items-center text-sm" data-id="element-316">
          <Download size={16} className="mr-2" data-id="element-317" /> সিএসভি এক্সপোর্ট করুন
        </button>
      </div>

      <div className="card overflow-hidden" data-id="element-318">
        <div className="p-4 border-b border-slate-200 bg-slate-50 flex flex-wrap gap-4 items-center justify-between" data-id="element-319">
          <div className="relative flex-1 min-w-[300px]" data-id="element-320">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" size={18} data-id="element-321" />
            <input type="text" placeholder="ব্যবহারকারী, পদক্ষেপ বা আইটেম আইডি দিয়ে খুঁজুন..." className="input-field pl-10 text-sm" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-322" />
          </div>
          <div className="flex space-x-3" data-id="element-323">
            <select className="input-field py-2 text-sm w-40" data-id="element-324">
              <option value="" data-id="element-325">সকল ভূমিকা</option>
              <option value="operator" data-id="element-326">অপারেটর</option>
              <option value="officer" data-id="element-327">অফিসার</option>
              <option value="admin" data-id="element-328">অ্যাডমিন</option>
              <option value="dsminland" data-id="element-329">ডিএস ভূমি মন্ত্রণালয়</option>
            </select>
            <button className="btn-secondary flex items-center text-sm px-3" data-id="element-330">
              <Calendar size={16} className="mr-2" data-id="element-331" /> তারিখের পরিসর
            </button>
          </div>
        </div>

        <div className="overflow-x-auto" data-id="element-332">
          <table className="min-w-full divide-y divide-slate-200" data-id="element-333">
            <thead className="bg-slate-50" data-id="element-334">
              <tr data-id="element-335">
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-336">
                  সময়কাল
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-337">
                  ব্যবহারকারী এবং ভূমিকা
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-338">
                  পদক্ষেপ
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-339">
                  আইটেম আইডি
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-340">
                  বিস্তারিত
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-slate-200" data-id="element-341">
              {filteredLogs.map(log => <tr key={log.id} className="hover:bg-slate-50" data-id="element-342">
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-500" data-id="element-343">
                    {new Date(log.timestamp).toLocaleString('bn-BD')}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-344">
                    <div className="text-sm font-medium text-slate-900" data-id="element-345">
                      {log.user}
                    </div>
                    <div className="text-xs text-slate-500 uppercase tracking-wide" data-id="element-346">
                      {log.role}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-347">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium
                      ${log.action.includes('Approve') || log.action.includes('Publish') ? 'bg-teal-100 text-teal-800' : log.action.includes('Reject') ? 'bg-red-100 text-red-800' : log.action.includes('Upload') ? 'bg-blue-100 text-blue-800' : 'bg-slate-100 text-slate-800'}`} data-id="element-348">
                      {log.action}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-slate-900" data-id="element-349">
                    {log.item}
                  </td>
                  <td className="px-6 py-4 text-sm text-slate-600 max-w-md" data-id="element-350">
                    {log.statusChange && <div className="text-xs font-semibold text-slate-800 mb-1" data-id="element-351">
                        {log.statusChange}
                      </div>}
                    <div className="truncate" title={log.details} data-id="element-352">
                      {log.details}
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
};